/**
 * Survives Partner Network route remounts within the SPA session
 * so date/partner filters are not reset when leaving and returning.
 */
let networkFilterCache = {
    startDate: undefined,
    endDate: undefined,
    selectedPartnerUid: undefined,
};

export const getNetworkFilterCache = () => networkFilterCache;

export const setNetworkFilterCache = (partial) => {
    networkFilterCache = {
        ...networkFilterCache,
        ...partial,
    };
};
